import * as React from 'react';

import { Notification } from 'farmhub-ui-core';

import { useAppDispatch, useAppSelector } from 'app';
import { findCategory, selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import SelectCategoriesStepDesktop from './SelectCategoriesStepDesktop';
import SelectCategoriesStepMobile from './SelectCategoriesStepMobile';

interface SelectCategoriesStepProps {
  data: any;
  setData: (e: any) => void;
}

const SelectCategoriesStep = ({
  data,
  setData,
}: SelectCategoriesStepProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const appDevice = useAppSelector(selectAppDevice);
  const categoryList = useAppSelector(state => state.category.list);
  const [isLoadingCategory, setIsLoadingCategory] = React.useState(false);

  const handleClickCategories = id => {
    if (data.categoryIDs.includes(id)) {
      const newArr = data.categoryIDs.filter(item => item !== id);
      setData({ ...data, categoryIDs: newArr });
    } else {
      const newArr = data.categoryIDs.concat(id);
      setData({ ...data, categoryIDs: newArr });
    }
  };

  const handleSelectAllOrDeleteCategories = () => {
    setData((prevState: any) => {
      if (prevState.categoryIDs.length > 0) {
        return { ...prevState, categoryIDs: [] };
      }
      return { ...prevState, categoryIDs: categoryList.map(item => item.id) };
    });
  };

  React.useEffect(() => {
    const initCategory = async () => {
      setIsLoadingCategory(true);
      try {
        await dispatch(findCategory()).unwrap();
      } catch (error: any) {
        Notification('error', 'Tải loại sản phẩm thất bại', error);
      }
      setIsLoadingCategory(false);
    };
    initCategory();
  }, [dispatch]);

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <SelectCategoriesStepDesktop
        data={data}
        handleClickCategories={handleClickCategories}
        handleSelectAllOrDeleteCategories={handleSelectAllOrDeleteCategories}
        isLoadingCategory={isLoadingCategory}
      />
    ),
    [DEVICES.MOBILE]: (
      <SelectCategoriesStepMobile
        data={data}
        handleClickCategories={handleClickCategories}
        handleSelectAllOrDeleteCategories={handleSelectAllOrDeleteCategories}
        isLoadingCategory={isLoadingCategory}
      />
    ),
    [DEVICES.TABLET]: (
      <SelectCategoriesStepMobile
        data={data}
        handleClickCategories={handleClickCategories}
        handleSelectAllOrDeleteCategories={handleSelectAllOrDeleteCategories}
        isLoadingCategory={isLoadingCategory}
      />
    ),
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default SelectCategoriesStep;
